import { useState, useMemo } from "react";
import { TourProvider } from "@reactour/tour";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createTourSteps } from "./tourSteps";
import { useSelector } from "react-redux";
import "./tour.css";

export default function TourWrapper({ children }) {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const persona = useSelector((state) => state.auth?.user?.persona || "tree_inspector");
  const [currentStep, setCurrentStep] = useState(0);

  const lang = i18n.language?.startsWith("it")
    ? "it"
    : i18n.language?.startsWith("en")
    ? "en"
    : "de";

  const steps = useMemo(() => createTourSteps(lang, navigate, persona), [lang, navigate, persona]);

  return (
    <TourProvider
      key={lang}
      steps={steps}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      styles={{
        popover: (base) => ({
          ...base,
          borderRadius: "10px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          padding: "1.25rem",
          minWidth: 280,
          maxWidth: 360,
        }),
        badge: (base) => ({
          ...base,
          background: "#1b6ca8",
          color: "#fff",
          fontSize: "0.7rem",
          padding: "2px 7px",
          borderRadius: "999px",
        }),
        dot: (base, state) => ({
          ...base,
          background: state?.current ? "#1b6ca8" : "#c0cfe0",
          width: 8,
          height: 8,
        }),
        arrow: (base, state) => ({
          ...base,
          color: state?.disabled ? "#c0cfe0" : "#1b6ca8",
        }),
      }}
    >
      {children}
    </TourProvider>
  );
}
